module.exports = __webpack_public_path__ + "media/bootstrap-icons/award-fill-9709e79d.svg";